<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="/secondHandCarMarket/findPublicSecondHandCarMarketList.action"
                    ref="Table">
      <template slot="search">
        <el-row>
          <el-form :inline="true" >
            <el-form-item>
              <el-select v-model="queryParams.type" :clearable="true" :filterable="true" placeholder="渠道类型">
                <el-option :value="1" label="金鱼塘二手车"></el-option>
                <el-option :value="2" label="华夏二手车"></el-option>
                <el-option :value="3" label="批批车二手车"></el-option>
                <el-option :value="4" label="车易批二手车"></el-option>
                <el-option :value="5" label="车千乘二手车"></el-option>
                <el-option :value="6" label="车行168新车"></el-option>
                <el-option :value="7" label="车小花内部二手车"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <brand-and-series-select-search  ref="brand-and-series-select-search" @onChanged="carCategoryChange"></brand-and-series-select-search>
            </el-form-item>

              <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="发布结束日期"
                  range-separator="至"
                  start-placeholder="发布开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>


            <el-form-item  >
              <el-input style="width: 200px" placeholder="关键词" v-model="queryParams.keyword"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="$refs.Table.search()" type="warning">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="$router.push({path:'/home/saveOrUpdateSencondMarket'})" type="primary">新增行情</el-button>
            </el-form-item>

          </el-form>
        </el-row>

      </template>
      <template slot="item">

        <el-table-column
            label="ID"
            width="120px"
        >
          <template slot-scope="scope">
            <p>ID:{{scope.row.id}} </p>
          </template>
        </el-table-column>
        <el-table-column
            label="品牌车型"

        >
          <template slot-scope="scope">
            <p>{{scope.row.brand}} {{scope.row.series}}</p>
            <p>{{scope.row.category}}</p>
          </template>
        </el-table-column>

        <el-table-column
            label="上牌地区"

        >
          <template slot-scope="scope">
            <p>{{scope.row.licenseAddress}}</p>
          </template>
        </el-table-column>



        <el-table-column
            label="里程"
        >
          <template slot-scope="scope">
            <p> 表显里程：{{scope.row.mileage?scope.row.mileage:0}}公里</p>

          </template>
        </el-table-column>

        <el-table-column
            label="上牌日期"

        >
          <template slot-scope="scope">
            <p>{{scope.row.licenseTime|dateFormat}}</p>
          </template>
        </el-table-column>

       <el-table-column
               width="120px"
            label="批发价"
            prop="businessPrice"
        >
         <template slot-scope="scope">
           <p>{{scope.row.businessPrice/100}}元</p>
         </template>
        </el-table-column>
        <el-table-column
            label="发布时间"
        >
          <template scope="scope">
            <p>{{scope.row.createTime | dateTimeFormat}}</p>
          </template>
        </el-table-column>
        <el-table-column
            label="修改时间"
        >
          <template scope="scope">
            <p>{{scope.row.createTime | dateTimeFormat}}</p>
          </template>
        </el-table-column>

        <el-table-column
                label="渠道"
                width="120px"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.type|secondMarketTypeFilter }}</p>
          </template>
        </el-table-column>




        <el-table-column
            label="操作"
            width="80px"
        >
          <template scope="scope">
            <el-button-group >
              <el-button type="text" @click.native.prevent="$router.push({name:'编辑车型行情', params: { id: scope.row.id }})"  size="mini">
                修改
                <el-divider direction="vertical"></el-divider>
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </template>
    </table-template>
    <el-dialog
        title="提示"
        :visible.sync="urlDialogVisible"
        width="30%"
        center>

      <el-input placeholder="请输入内容" v-model="urlVal">

      </el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="urlDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="urlDialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'
import Config from '@/framework/configs/Config'
import BrandAndSeriesSelectSearch from '@/components/BrandAndSeriesSelectSearch'

export default {
  components: {
    TableTemplate,
    BrandAndSeriesSelectSearch

  },
  extends: BasicPager,
  name: 'secondMarketManagement',
  data: function () {
    return {
      urlDialogVisible: false,
      urlVal: '暂无',
      queryParams: {
        type: null,
        startTime: null,
        endTime: null,
        brand:null,
        series:null,
        keyword: null
      }
    }
  },
  activated: function () {
    this.$refs.Table.search()
  },
  watch: {
    'queryParams.type': function () {
      this.$refs.Table.search()
    },

  },
  methods: {
    carCategoryChange: function (brandInfo, seriesInfo) {
      // 品牌车系车型
      if (brandInfo && brandInfo.name) {
        this.queryParams.brand = brandInfo.name
      } else {
        this.queryParams.brand = null
      }

      if (seriesInfo && seriesInfo.name) {
        this.queryParams.series = seriesInfo.name
      } else {
        this.queryParams.series = null
      }
      this.$refs.Table.search()

  },
    onInputConfirm: function () {
      this.$refs.Table.search()
    }
    ,
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.Table.search()
    }
  },
  filters: {
    secondMarketTypeFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '金鱼塘'
          break
        case 2:
          str = '华夏二手车'
          break
        case 3:
          str = '批批车'
          break
        case 4:
          str = '车易批'
          break
        case 5:
          str = '车千乘'
          break
        case 6:
          str = '车行168'
          break
        case 7:
          str = '车小花'
          break
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
